<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'device_typesCrud'"
            :crudName="$t('Device Types')"
            :newText="$t('Add')+ '  '+$t('New')"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "device_typesTable",
      showMessageImport: false,
      device_typesCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "image",
        "name",
        "actions",
      ],
      tableData: ["id", "name"],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name"],
        sortable: ["id", "name"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort",
        },
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('id'),
          image: this.$t('Icon'),
          name: this.$t('name'),
          actions: this.$t('action'),
        },

        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        listColumns: {},
        templates: {
          image: function (h, row) {
            return row.upload_files
                ? h('b-avatar', {props: {src: row.upload_files.url, size: '2rem'}})
                : '';
          },
        },
        requestFunction: function (data) {
          let requestData = {};


          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "deviceTypes",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('id'),
        image: this.$t('Icon'),
        name: this.$t('name'),
        actions: this.$t('action'),
      }
      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      }
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      }
    }
  },
  methods: {
    query: function (query) {
      let columns = {
        id: 'id',
        name: 'name',
        actions: this.$t('action'),

      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

</style>
